
  var _styles = {
  "wish-selection-popup-container": {
    "width": "10rem",
    "background": "rgba(0,0,0,0)",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "position": "relative"
  },
  "wish-selection-popup-header": {
    "width": "100%",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": "0.26667rem",
    "paddingLeft": 0,
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "wish-selection-popup-scroll-container": {
    "width": "10rem"
  },
  "wish-row-container": {
    "height": "1.86667rem",
    "position": "relative"
  },
  "wish-row-content": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline"
  },
  "wish-option-card": {
    "width": "5.48rem",
    "height": "1.2rem"
  },
  "wish-selection-popup-footer": {
    "width": "100%",
    "marginTop": "0.6rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "wish-confirm-button": {
    "width": "5.12rem",
    "height": "1.2rem",
    "borderRadius": "0.64rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "boxShadow": "0px 0.10667rem 0.21333rem rgba(255,221,0,.3)"
  },
  "wish-confirm-button-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.48rem",
    "lineHeight": "0.64rem"
  },
  "wish-selection-popup-close-btn": {
    "cursor": "pointer"
  }
};



  module.exports = _styles;
  